
<template>
  <div id="app" :class="bodyClass">
    <!--    Header Section-->
    <router-view name="header"/>
    <!--    Body Section-->
    <router-view/>
    <!--    Footer Section-->
    <router-view name="footer"/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      bodyClass: ''
    }
  },
  watch: {
    "$route.path": function (path) {
      //Inject css base on router path
      if (path === '/404' || path === '/pages/login' || path === '/pages/sign-up') {
        this.bodyClass = 'notfound';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue